import {
  RefundRequest,
  SettleRefundPayload,
  RejectRefundPayload,
} from "types/refund";
import {
  getPendingRefunds as getPendingRefundsApi,
  settleReturn as settleReturnApi,
  rejectReturn as rejectReturnApi,
} from "utils/AxiosUtil";
import { NetworkType } from "utils/network";

async function getRefunds(
  merchantId: string,
  network: NetworkType,
  token?: string,
): Promise<RefundRequest[]> {
  const res = await getPendingRefundsApi(merchantId, network, token);
  return res.data;
}

async function settleReturn(
  payload: SettleRefundPayload,
  network: NetworkType,
): Promise<void> {
  await settleReturnApi(payload, network);
}

async function rejectReturn(
  payload: RejectRefundPayload,
  network: NetworkType,
): Promise<void> {
  await rejectReturnApi(payload, network);
}

const return_services = {
  getRefunds,
  settleReturn,
  rejectReturn,
};

export default return_services;
